/**
* 订单管理 交易订单
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>商家付款记录</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
     <el-form-item label="银行卡号">
       <el-input size="small" v-model="formInline.bankNo" placeholder="银行卡号"></el-input>
     </el-form-item>
     <el-form-item label="商家名称">
       <el-input size="small" v-model="formInline.mchName" placeholder="商家名称"></el-input>
     </el-form-item>
     <el-form-item label="开户名">
       <el-input size="small" v-model="formInline.realName" placeholder="开户名"></el-input>
     </el-form-item>
     <el-form-item label="选泽日期：">
     	<el-date-picker value-format='timestamp' v-model="formInline.value1" type="daterange"
     		range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
     	</el-date-picker>
     </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
      element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column prop="transId" label="id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mchId" label="商家id" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mchName" label="商家名称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mark" label="打款账户" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cardRealName" label="收款人" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="cardNo" label="收款账户" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="transAmount" label="储值金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mchInitialAmount" label="储值前金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="transReceiptName" label="回执单" show-overflow-tooltip>
        <template slot-scope="scope">
          <!-- <a :href="' + item.id"></a -->
          <el-link type="danger" :href="['https://yihai-image.oss-cn-beijing.aliyuncs.com/merchantTransferMoney/beijing/'+scope.row.transReceiptName]"
            target="_blank">点击查看</el-link>
        </template>

      </el-table-column>
      <el-table-column prop="mchFinalAmount" label=" 储值后金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="transDate" label="储值时间" show-overflow-tooltip></el-table-column>
      <!--  <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">预览</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">退款</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->

  </div>
</template>

<script>
  import {
    getMerchantTransFlowPage,

  } from '../../api/userMG'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        title: '预览',
        editForm: {
          id: '',
          name: '',
          payType: 1,
          partner: '',
          subMchId: '',
          appid: '',
          notifyUrl: '',
          signType: '',
          partnerKey: '',
          sellerUserId: '',
          certPath: '',
          certPassword: '',
          rsaKey: '',
          token: localStorage.getItem('logintoken')
        },
        formInline: {
          page: 1,
          limit: 20,
          bankNo:'',
          realName:'',
          orderId:'',
          value1:''
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 20,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 数据发生改变
     */

    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },


    methods: {
      getdata(parameter) {

        let pro = {
          "userId": JSON.parse(localStorage.getItem('userdata')).muId,
          "page": parameter.page,
           "pageSize": parameter.limit,
          "bankNo": parameter.bankNo,
          "mchName": parameter.mchName,
          "realName": parameter.orderId,
          "startDate": parameter.value1[0] / 1000,
          "endDate": parameter.value1[1] / 1000,
        }

        getMerchantTransFlowPage(pro)
          .then(res => {
            this.loading = false
            if (res.code == 0) {
              this.listData = res.data.list
              // 分页赋值
              this.pageparm.currentPage = res.data.pageNum
              this.pageparm.pageSize = res.data.pageSize
              this.pageparm.total = res.data.total

            } else {
            	  this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
          .catch(err => {
            this.loading = false
            // this.$message.error('菜单加载失败，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      },
      // 搜索事件
      search() {
        this.getdata(this.formInline)
      },

    }
  }
</script>

<style scoped>
  .user-search {
    margin-top: 20px;
  }

  .userRole {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/pay/StoredList.vue